export const STEP_MSA_ATTORNEY = 1;
export const STEP_CLIENT_ATTORNEY = 2;